<style lang="less" scoped>
.title {
  font-size: 28px;
  text-align: center;
  padding: 20px 0;
}
.video-list {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  flex-wrap: wrap;
  min-height: 555px;
  .item {
    width: 25%;
    min-width: 230px;
    height: 165px;
    background-color: #fff;
    position: relative;
    margin-left: 20px;
    margin-top: 20px;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    .text {
      text-align: center;
    }
    .msk {
      display: none !important;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(123, 122, 122, 0.7);
      img {
        width: 40px;
        height: 40px;
      }
    }
    > img {
      width: 100%;
    }
  }
  .item:hover {
    .msk {
      transition: all 10s ease-in;
      display: flex !important;
      justify-content: center;
      align-items: center;
      img {
        cursor: pointer;
      }
    }
  }
}
.list-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>
<template>
  <div class="video-center">
    <div class="title">视频中心</div>
    <div class="video-list">
      <div class="item" v-for="(item, index) in videoList" :key="index">
        <div class="msk">
          <img
            src="@/assets/images/icon/play.svg"
            @click="clickPlay(item.src)"
          />
        </div>
        <img :src="item.coverImg" />
        <div class="text">{{ item.title }}</div>
      </div>
    </div>
    <div class="list-footer">
      <Page
        :total="total"
        :show-total="true"
        @on-change="changePageNo"
        :page-size="pageSize"
        size="small"
      />
    </div>
    <videoBox
      v-if="showVideo"
      :video="videoPath"
      :showVideo="showVideo"
      @closeVideo="closeVideo"
    />
  </div>
</template>

<script>
import videoBox from "components/video/VideoBox";
import { group } from "static/common.js";
import axios from "axios";
export default {
  components: {
    videoBox,
  },
  data() {
    return {
      showVideo: false,
      videoPath: "",
      videoList: [],
      allList: [],
      groupList: [],
      total: 0,
      pageNo: 1,
      pageSize: 9,
      data: [],
    };
  },
  methods: {
    reqVideoList() {
      axios.get("./data.json").then((res) => {
        this.total = res.data.videoList.length;
        this.allList = res.data.videoList;
        this.groupList = group(this.allList, this.pageSize);
        this.videoList = this.groupList[this.pageNo - 1];
      });
    },
    changePageNo(e) {
      this.pageNo = e;
      this.videoList = this.groupList[this.pageNo - 1];
    },
    clickPlay(src) {
      this.showVideo = true;
      this.videoPath = src;
    },
    closeVideo(e) {
      this.showVideo = e;
    },
  },
  mounted() {
    this.reqVideoList();
  },
};
</script>

 